import React, { useContext, useEffect } from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'

declare global {
    interface Window {
        hbspt?: {
            forms: {
                create: (options: {
                    portalId: string | undefined
                    formId: string | undefined
                    target: string
                    onFormReady?: () => void
                }) => void
            }
        }
    }
}

const HelpDeskQuestionForm = () => {
    const { userStore, preloaderStore } = useContext(StoresContext)

    const preloadUserData = () => {
        preloaderStore.openMainPreloader(false)
        const firstNameInput = document.querySelector('input[name="firstname"]') as HTMLInputElement
        const lastNameInput = document.querySelector('input[name="lastname"]') as HTMLInputElement
        const emailInput = document.querySelector('input[name="email"]') as HTMLInputElement
        if (userStore.userInfo) {
            if (firstNameInput) {
                firstNameInput.value = userStore.userInfo.firstName
                firstNameInput.dispatchEvent(new Event('input', { bubbles: true }))
                firstNameInput.dispatchEvent(new Event('change', { bubbles: true }))
                firstNameInput.readOnly = true
            }
            if (lastNameInput) {
                lastNameInput.value = userStore.userInfo.lastName
                lastNameInput.dispatchEvent(new Event('input', { bubbles: true }))
                lastNameInput.dispatchEvent(new Event('change', { bubbles: true }))
                lastNameInput.readOnly = true
            }
            if (emailInput) {
                emailInput.value = userStore.userInfo.email
                emailInput.dispatchEvent(new Event('input', { bubbles: true }))
                emailInput.dispatchEvent(new Event('change', { bubbles: true }))
                emailInput.readOnly = true
            }
        }
    }

    useEffect(() => {
        preloaderStore.openMainPreloader(true)

        const createForm = () => {
            if (window.hbspt && window.hbspt.forms) {
                window.hbspt.forms.create({
                    portalId: window.APP_CONFIG.HUBSPOT_PORTAL_ID,
                    formId: window.APP_CONFIG.HUBSPOT_CONTACT_US_FORM_ID,
                    target: '#hubspotForm',
                    onFormReady: () => {
                        preloadUserData()
                    },
                })
            }
        }

        if (window.hbspt && window.hbspt.forms) {
            createForm()
        } else {
            const script = document.createElement('script')
            script.src = 'https://js.hsforms.net/forms/v2.js'
            script.async = true
            script.onload = createForm
            document.body.appendChild(script)
        }

        return () => {
            document.getElementById('hubspotForm')?.replaceChildren()
        }
    }, [])

    return (
        <div className="contact-us-form-wrapper">
            <img src={ICONS.email} />
            <div id="hubspotForm" />
        </div>
    )
}

export default HelpDeskQuestionForm
